import { useEffect } from 'react'
import useProgressBar from 'features/ad/progressBar/useProgressBar'
import useDashboardReferrer, {
  DASHBOARD_REFERRER,
} from 'features/ad/useDashboardReferrer'
import { batch, useDispatch, useSelector } from 'react-redux'
import {
  fetchBizChannel,
  fetchCreativeLinks,
  fetchCreatives,
  reset,
} from 'features/ad/creative/groupCreativeSlice'
import {
  Route,
  Switch,
  useHistory,
  useParams,
  useRouteMatch,
} from 'react-router-dom'
import { fail } from 'features/toast/Toast'
import SelectCreative from 'features/ad/creative/SelectCreative'
import {
  fetchCampaign,
  reset as campaignReset,
} from 'features/ad/campaign/campaignSlice'
import {
  fetchAdGroup,
  reset as adGroupReset,
} from 'features/ad/group/adGroupSlice'
import LoadingWrapper from 'components/loading/LoadingWrapper'
import SaveAsCreative from 'features/ad/creative/SaveAsCreative'
import GroupCreativeAdd from './GroupCreativeAdd'

const progress = {
  [DASHBOARD_REFERRER.CAMPAIGN]: [
    {
      text: '캠페인 만들기',
      done: true,
    },
    {
      text: '광고그룹 만들기',
      done: true,
    },
    {
      text: '키워드 만들기',
      done: true,
    },
    {
      text: '소재 선택하기',
      active: true,
    },
  ],
  [DASHBOARD_REFERRER.AD_GROUP]: [
    {
      text: '광고그룹 만들기',
      done: true,
    },
    {
      text: '키워드 만들기',
      done: true,
    },
    {
      text: '소재 선택하기',
      active: true,
    },
  ],
  [DASHBOARD_REFERRER.CREATIVE]: null,
}
const GroupCreative = () => {
  const dispatch = useDispatch()
  const { channel, isCreativeLoading, isChannelLoading } = useSelector(
    state => state.ad.groupCreative
  )
  const { accountId: adAccountId } = useParams()
  const referrer = useDashboardReferrer()
  const { path, url } = useRouteMatch()
  const { campaignId, adGroupId } = useParams()
  const history = useHistory()
  useProgressBar(progress[referrer || DASHBOARD_REFERRER.CAMPAIGN])

  useEffect(() => {
    ;(async () => {
      const { error: campaignError, payload: campaignPayload } = await dispatch(
        fetchCampaign(campaignId)
      )
      if (campaignError) {
        const { errorCode, errorMessage } = campaignPayload
        if (errorCode === 409) {
          fail('삭제된 캠페인 입니다.')
        } else {
          fail(errorMessage || '알 수 없는 에러가 발생했습니다')
        }
        history.push(`/${adAccountId}/dashboard`)
      } else {
        const { error: adGroupError, payload: adGroupPayload } = await dispatch(
          fetchAdGroup(adGroupId)
        )
        if (adGroupError) {
          const { errorCode, errorMessage } = adGroupPayload
          if (errorCode === 409 || errorCode === 104007) {
            fail('삭제된 광고그룹 입니다.')
          } else {
            fail(errorMessage || '알 수 없는 에러가 발생했습니다')
          }
          history.push(`/${adAccountId}/dashboard`)
        } else {
          const { bizChannelId } = campaignPayload.campaign
          dispatch(fetchCreatives(bizChannelId))
          dispatch(fetchBizChannel(bizChannelId))
          dispatch(fetchCreativeLinks(adGroupId))
        }
      }
    })()
  }, [dispatch, adAccountId, adGroupId, campaignId, history])

  useEffect(
    () => () => {
      batch(() => {
        dispatch(adGroupReset())
        dispatch(campaignReset())
        dispatch(reset())
      })
    },
    [dispatch]
  )

  return (
    <LoadingWrapper isLoading={isChannelLoading || isCreativeLoading}>
      <div className="wrap_material new_material">
        <Switch>
          <Route exact path={`${path}/new`}>
            <GroupCreativeAdd
              channel={channel}
              onClickOtherTab={() =>
                history.push(`${url}${referrer ? `?from=${referrer}` : ''}`)
              }
            />
          </Route>
          <Route exact path={`${path}/save-as/:creativeId(\\d+)`}>
            <SaveAsCreative />
          </Route>
          <Route exact path={`${path}`}>
            <SelectCreative referrer={referrer} />
          </Route>
        </Switch>
      </div>
    </LoadingWrapper>
  )
}

export default GroupCreative
